import React from 'react'
import { connect } from 'react-redux'
import { Button, Menu, MenuButton, MenuList, MenuItem } from '@chakra-ui/core'
import { RootState } from '../../constants/interfaces'
import { setLocale } from '../../redux/actions/general'
import { getLanguageName } from 'utils/languageName'

interface LocaleDropDownProps {
  setLocale: (locale: any) => void
  translationsKeys: string[]
  translations: RootState['config']['translations']
  locale: string
}

const LocaleDropDown = ({ locale, setLocale, translationsKeys, translations }: LocaleDropDownProps): JSX.Element => {
  return (
    <Menu>
      <MenuButton as={Button} borderRadius="20px" px={5} textTransform="capitalize">
        {getLanguageName(locale, translations?.[locale])}
      </MenuButton>
      <MenuList>
        {translationsKeys.map((item: string, index: number) => (
          <MenuItem
            key={index}
            onClick={() => setLocale(item)}
            textTransform="capitalize"
            style={{
              borderRadius: '4px',
              fontWeight: locale === item ? 'bold' : 'inherit',
            }}
          >
            {getLanguageName(item, translations?.[item])}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  )
}

const mapStateToProps = ({ general, config }: RootState) => ({
  locale: general.locale,
  translationsKeys: config.translationsKeys,
  translations: config.translations,
})

export default connect(mapStateToProps, { setLocale })(LocaleDropDown)
